import styled from 'styled-components'

export const Heading3 = styled.h3``
